// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"eb7f4725","64":"2e9f9d6f","232":"9e2df040","436":"635f3b42","900":"e1b57575","941":"c895724b"}[chunkId] + ".chunk.js";
};